// src/utils/analytics.js
import ReactGA from 'react-ga4';

export const initGA = (): void => {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || 'fake-id');
};

export const logPageView = (url: string): void => {
    ReactGA.send({ hitType: 'pageview', page: url });
};

export const logEvent = ({
    category,
    action,
    label,
}: {
    category: string;
    action: string;
    label?: string;
}): void => {
    ReactGA.event({
        category,
        action,
        label,
    });
};
